import { render, staticRenderFns } from "./CompanyTagDeleteDialog.vue?vue&type=template&id=54848007&scoped=true"
import script from "./CompanyTagDeleteDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyTagDeleteDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54848007",
  null
  
)

export default component.exports